import { useTranslation } from 'react-i18next';
import { TypedTFunction, translations, TranslationNamespace } from '@app/models';

export function useTypedTranslation(namespace?: TranslationNamespace): { translation: TypedTFunction<typeof translations> } {
    const { t } = useTranslation(namespace);
    return {
        translation(...keys: string[]) {
            return t(keys.join('.'));
        }
    };
}
